import { memo } from 'react';

export const Alert = memo(({ children, className = "" }) => {
  return (
    <div className={`rounded-lg border p-4 ${className}`} role="alert">
      {children}
    </div>
  );
});

Alert.displayName = "Alert";

export const AlertDescription = memo(({ children, className = "" }) => {
  return (
    <div className={`text-sm [&_p]:leading-relaxed ${className}`}>
      {children}
    </div>
  );
});

AlertDescription.displayName = "AlertDescription";